export default {
    product: {
        description: {
            more: "több"
        },
        added: "Hozzáadva a kosárhoz"
    }
}